import ctl from '@netlify/classnames-template-literals';

export const classes = {
  range: ctl(`
    mt-2 
    text-sm 
    text-center 
    text-chinese-silver
    select-none
  `),
};
